const heroItems = [
  {
    title: (
      <>
        Own your
        <br /> dream <span className="text-primary">phone.</span>
      </>
    ),
    description: "You dream it, we provide it.",
    imageUrl: "/assets/images/smartphone.webp",
    imageAlt: "smartphone",
  },
  {
    title: (
      <>
        Get the <span className="text-primary">tools</span> your
        <br className="lg:hidden" /> business needs.
      </>
    ),
    description: "You dream it, we provide it.",
    imageUrl: "/assets/images/tools.webp",
    imageAlt: "tools",
  },
  {
    title: (
      <>
        A <span className="text-primary">bike</span> that works
        <br /> as hard as you do
      </>
    ),
    description: "You dream it, we provide it.",
    imageUrl: "/assets/images/bike-2.webp",
    imageAlt: "bike",
  },
  {
    title: (
      <>
        <span className="text-primary">Power</span> your
        <br /> business growth
      </>
    ),
    description: "You dream it, we provide it.",
    imageUrl: "/assets/images/solar-power-technician.webp",
    imageAlt: "solar power technician on a rooftop",
  },
  {
    title: (
      <>
        Reliable <span className="text-primary">power</span>
        <br /> for everyday life
      </>
    ),
    description: "You dream it, we provide it.",
    imageUrl: "/assets/images/power-system.webp",
    imageAlt: "power system",
  },
];

const financingItems = [
  {
    title: "Phones",
    cta: "Get a Phone",
    imageUrl: "/assets/images/smartphone-2.webp",
    link: "/",
  },
  {
    title: "Bikes",
    cta: "Own a Bike",
    imageUrl: "/assets/images/bike.webp",
    link: "/",
  },
  {
    title: "Energy Assets",
    cta: "Let's Talk",
    imageUrl: "/assets/images/inverter-system-2.webp",
    link: "/",
  },
  {
    title: "Agricultural Assets",
    cta: "Let's Talk",
    imageUrl: "/assets/images/tractor.webp",
    link: "/",
  },
];

const beyondItems = [
  {
    id: 1,
    title: "Device Protection",
    description: "Complete coverage against damage and accident",
    imageUrl: "/assets/images/beyond-img-1.webp",
  },
  {
    id: 2,
    title: "Health Coverage",
    description: "Get hospital and healthcare coverage with your smartphone",
    imageUrl: "/assets/images/beyond-img-2.webp",
  },
  {
    id: 3,
    title: "Easy Installments",
    description: "Flexible payment plans that fit your budget",
    imageUrl: "/assets/images/beyond-img-3.webp",
  },
  {
    id: 4,
    title: "Edge Coverage",
    description: "Extended protection and support wherever you are",
    imageUrl: "/assets/images/beyond-img-4.webp",
  },
  {
    id: 5,
    title: "Fast Approvals",
    description: "Get approved and start using your device today",
    imageUrl: "/assets/images/beyond-img-5.webp",
  },
];

const sdgImages = [
  { id: 1, src: "/assets/images/sdg-goals/sdg-img-1.webp", alt: "No Poverty" },
  {
    id: 2,
    src: "/assets/images/sdg-goals/sdg-img-3.webp",
    alt: "Good Health and Well-Being",
  },
  {
    id: 3,
    src: "/assets/images/sdg-goals/sdg-img-5.webp",
    alt: "Gender Equality",
  },
  {
    id: 4,
    src: "/assets/images/sdg-goals/sdg-img-7.webp",
    alt: "Affordable and Clean Energy",
  },
  {
    id: 5,
    src: "/assets/images/sdg-goals/sdg-img-8.webp",
    alt: "Decent Work and Economic Growth",
  },
  {
    id: 6,
    src: "/assets/images/sdg-goals/sdg-img-10.webp",
    alt: "Reduced Inequalities",
  },
  {
    id: 7,
    src: "/assets/images/sdg-goals/sdg-img-13.webp",
    alt: "Climate Action",
  },
];

const testimonials = [
  {
    id: 1,
    bgImageUrl: "/assets/images/testimonial-img-1.webp",
    message:
      "Pluck made it possible for me to power my shop at night without electricity using inverters and energy solutions from them.",
  },
  {
    id: 2,
    bgImageUrl: "/assets/images/testimonial-img-2.webp",
    message:
      "Pluck made it possible for me to get the phone I needed without financial stress. The process was incredibly smooth!",
  },
];

const faqs = [
  {
    id: 1,
    question: "When will I start paying for my device?",
    answer: (
      <>
        After making the initial payment, you will be given a 1-day grace
        period. Your daily payment will begin the day after the grace period.
        <br />
        <br />
        <strong>Example:</strong>
        <br />
        Initial payment made on 15th
        <br />
        16th = grace period (no payment)
        <br />
        17th = daily payment begins
      </>
    ),
  },
  {
    id: 2,
    question: "Is the initial payment part of the device price?",
    answer:
      "No. The initial payment is not part of the device price. The full device cost will still be paid through your daily payments.",
  },
  {
    id: 3,
    question: "How much do I pay daily?",
    answer: (
      <>
        Your daily payment amount depends on your plan:
        <br />
        <br />
        • The device type you choose, and
        <br />• The payment duration (either 100 days or 200 days).
      </>
    ),
  },
  {
    id: 4,
    question: "How many days will I be paying?",
    answer:
      "You will be paying for either 100 days or 200 days, depending on the payment plan you choose.",
  },
  {
    id: 5,
    question: "Can I pay more than the daily amount?",
    answer: (
      <>
        Yes. You can pay more than the daily amount to cover multiple days
        ahead, but payments will still be applied daily until the total number
        of days is completed.
        <br />
        <br />
        <strong>Example:</strong> If your daily payment is ₦1,000 and you pay
        ₦10,000, it will cover 10 days.
      </>
    ),
  },
  {
    id: 6,
    question: "What happens if I don't pay?",
    answer: (
      <>
        If you miss a payment, your device will be temporarily locked until you
        resume payment.
        <br />
        <br />
        If payments continue to be missed after locking, the device will be
        collected by the sales agent in charge.
      </>
    ),
  },
  {
    id: 7,
    question: "Is the device covered by insurance?",
    answer:
      "Yes, the device is partially covered by insurance, but it does not cover physical damage. Customers are responsible for physical damage.",
  },
];

const partners = [
  {
    id: 1,
    name: "Airtel",
    imageUrl: "/assets/images/partners/airtel.webp",
    width: 79.4,
    height: 27.8,
  },
  {
    id: 2,
    name: "Bajaj",
    imageUrl: "/assets/images/partners/bajaj.webp",
    width: 97.44,
    height: 20.74,
  },
  {
    id: 3,
    name: "itel",
    imageUrl: "/assets/images/partners/itel.webp",
    width: 59.37,
    height: 32.98,
  },
  {
    id: 4,
    name: "Qlink",
    imageUrl: "/assets/images/partners/qlink.webp",
    width: 53.65,
    height: 35.77,
  },
  {
    id: 5,
    name: "Xiaomi",
    imageUrl: "/assets/images/partners/xiaomi.webp",
    width: 92.27,
    height: 29.31,
  },
  {
    id: 6,
    name: "Samsung",
    imageUrl: "/assets/images/partners/samsung.webp",
    width: 105.87,
    height: 17.69,
  },
  {
    id: 7,
    name: "MTN",
    imageUrl: "/assets/images/partners/mtn.webp",
    width: 52.22,
    height: 29.37,
  },
];

const appDownloadLinks = [
  // {
  //   id: 1,
  //   title: "Apple Store",
  //   imageUrl: "/assets/images/badges/appstore-badge.webp",
  //   link: "/",
  //   alt: "Apple Store Badge",
  //   width: 153,
  //   height: 51,
  // },
  {
    id: 2,
    title: "Google Play Store",
    imageUrl: "/assets/images/badges/playstore-badge.webp",
    link: "https://play.google.com/store/apps/details?id=com.reeddi.pluckCustomer",
    alt: "Google Play Store Badge",
    width: 172,
    height: 51,
  },
];

const entrepreneurOutcomes = [
  "Grow and sustain their businesses",
  "Increase household income",
  "Access healthcare and device protection",
  "Build credit histories for future financial opportunities",
  "Participate more fully in the digital economy",
];

export {
  entrepreneurOutcomes,
  heroItems,
  financingItems,
  beyondItems,
  sdgImages,
  testimonials,
  faqs,
  partners,
  appDownloadLinks,
};
